import React, {useState, useEffect, useContext} from 'react';
import { DataContext } from 'contexts/DataContext';

import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';
import Info from '@mui/icons-material/Info';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';

import AppLayout from 'components/AppLayout/AppLayout';
import AppDrawer from 'components/AppDrawer/AppDrawer';
import WarningIcon from '@mui/icons-material/Warning';
import CheckCircle from '@mui/icons-material/CheckCircle';

import { get } from './api';
import 'i18n/config';
import { useTranslation } from 'react-i18next';
import { get as getContext } from 'pages/Context/api';
import { get as getImpact } from 'pages/Impact/api';

function Risks() {
  const { t } = useTranslation();
  const dataContext = useContext(DataContext);
  const [risks, setRisks] = useState(false as any);
  const [impact, setImpact] = useState({} as any);
  const [context, setContext] = useState({} as any);

  const colors = {      
    '-': '',
    0: '#FFFFFF',
    1: '#2CC937',
    2: '#99C140',
    3: '#E7B417',
    4: '#DB7B2A',
    5: '#CC3232'
  } as any;

  useEffect(()=>{
    if(dataContext.loading) return;
    if(!dataContext.currentAssessment) return;
    getImpact(dataContext.currentAssessment).then((response) => {
      setImpact(response);
      console.log('impact',response);
    });

    getContext(dataContext.currentAssessment, 0).then((response) => {
      setContext(response);
      console.log('context',response);
    });
  },[dataContext.loading,dataContext.currentAssessment]);


  useEffect(() => {
    dataContext.changeShowLoader(true);
    if(dataContext.loading) return;
    if(!dataContext.currentOrganization) return;
    if(!dataContext.currentAssessment) return;
    
    get(dataContext.currentAssessment).then((response) => {
      setRisks(response);
      dataContext.changeShowLoader(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [dataContext.loading,dataContext.currentOrganization,dataContext.currentAssessment]);


  return (
    <AppLayout drawerOpen={true} drawer={<AppDrawer />} 
        title={<><Typography variant='pageTitle'>{t('Risks')}</Typography></>}>
      
      {context.context?.length===0 && impact.length===0 && <Alert sx={{marginBottom:1}} severity="warning">{t('Please fill Impact and Context under Scope section.')}</Alert>}

      {risks && (
        <TableContainer
          sx={{
            backgroundColor: (theme) => theme.palette.background.paper,
            borderRadius: 5,
            border: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
      <Table size={'small'} sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell rowSpan={2}>ID</TableCell>
            <TableCell rowSpan={2}>{t('Threat')}</TableCell>
            <TableCell rowSpan={2} align="center">{t('Prob')}</TableCell>
           {/*
            <TableCell rowSpan={2} align="center" sx={{borderRight:'1px solid rgba(0, 0, 0, 0.12)'}}>{t('Fearsomeness')}</TableCell>
          */}
            <TableCell colSpan={3} align="center" sx={{borderRight:'1px solid rgba(0, 0, 0, 0.12)'}}>{t('Applicability')}</TableCell>
          
            <TableCell colSpan={4} align="center" sx={{borderRight:'1px solid rgba(0, 0, 0, 0.12)'}}>
              {t('Potential risk')}
              <Tooltip title={<div dangerouslySetInnerHTML={{__html:t('Livello di rischio calcolato senza considerare le contromisure implementate a contrasto delle minacce applicabili.')}}></div>}>
                  <Info sx={{fontSize:14, marginLeft:1}}/>
                </Tooltip>
            </TableCell>
            <TableCell colSpan={4} align="center">
              {t('Effective risk')}
              <Tooltip title={<div dangerouslySetInnerHTML={{__html:t('livello di rischio calcolato considerando le contromisure implementate a contrasto delle minacce  applicabili.')}}></div>}>
                  <Info sx={{fontSize:14, marginLeft:1}}/>
                </Tooltip>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell align="center">{t('R')}</TableCell>
            <TableCell align="center">{t('I')}</TableCell>
            <TableCell align="center" sx={{borderRight:'1px solid rgba(0, 0, 0, 0.12)'}}>{t('D')}</TableCell>
            
            <TableCell align="center">{t('R')}</TableCell>
            <TableCell align="center">{t('I')}</TableCell>
            <TableCell align="center">{t('D')}</TableCell>
            <TableCell align="center" sx={{borderRight:'1px solid rgba(0, 0, 0, 0.12)'}}>{t('MAX')}</TableCell>

            <TableCell align="center">{t('R')}</TableCell>
            <TableCell align="center">{t('I')}</TableCell>
            <TableCell align="center">{t('D')}</TableCell>
            <TableCell align="center">{t('MAX')}</TableCell>

          </TableRow>
        </TableHead>
        <TableBody>
          {risks.map((risk: any, index:number) => {
            return <TableRow key={index} sx={{ 'height':'50px'}}>
              <TableCell component="th" scope="row">{risk.id}</TableCell>
              <TableCell>
                <Box sx={{display:'flex', flexDirection:'row', alignItems:'center'}}>
                <Tooltip title={<div dangerouslySetInnerHTML={{__html:risk.samples}}></div>}>
                  <Info sx={{fontSize:14, marginRight:1}}/>
                </Tooltip>
                {risk.name}                                 
                </Box>
              </TableCell>

              <TableCell align="center" sx={{
                backgroundColor: colors[Math.round(risk.context_probability>5 ? 5 : risk.context_probability)],
                color: (theme) => {
                  const bg = colors[Math.round(risk.context_probability>5 ? 5 : risk.context_probability)];
                  return bg ? theme.palette.getContrastText(bg) : theme.palette.text.primary;
                },
              }}>{Math.round(risk.context_probability>5 ? 5: risk.context_probability)}</TableCell>
              {/* 
              <TableCell align="center"sx={{borderRight:'1px solid rgba(0, 0, 0, 0.12)', backgroundColor:colors[risk.fearsomeness], color:'#000'}}>{risk.fearsomeness}</TableCell>
              */}
              <TableCell align="center">{parseInt(risk.R)===1 && <CheckCircle sx={{fontSize:14}} />}</TableCell>
              <TableCell align="center">{parseInt(risk.I)===1 && <CheckCircle sx={{fontSize:14}} />}</TableCell>
              <TableCell align="center" sx={{borderRight:'1px solid rgba(0, 0, 0, 0.12)'}}>{parseInt(risk.D)===1 && <CheckCircle sx={{fontSize:14}} />}</TableCell>

              <TableCell align="center" sx={{
                backgroundColor: colors[parseInt(risk.R)===1 ? Math.ceil(risk.risks.confidentiality) : '-'],
                color: (theme) => {
                  const idx = parseInt(risk.R)===1 ? Math.ceil(risk.risks.confidentiality) : '-';
                  const bg = colors[idx];
                  return bg ? theme.palette.getContrastText(bg) : theme.palette.text.primary;
                },
              }}>{(context.context?.length===0 && impact.length===0) ? '-' : parseInt(risk.R)===1 ? risk.risks.confidentiality : ''}</TableCell>
              <TableCell align="center" sx={{
                backgroundColor: colors[parseInt(risk.I)===1 ? Math.ceil(risk.risks.integrity) :  '-'],
                color: (theme) => {
                  const idx = parseInt(risk.I)===1 ? Math.ceil(risk.risks.integrity) : '-';
                  const bg = colors[idx];
                  return bg ? theme.palette.getContrastText(bg) : theme.palette.text.primary;
                },
              }}>{(context.context?.length===0 && impact.length===0) ? '-' : parseInt(risk.I)===1 ? risk.risks.integrity : ''}</TableCell>
              <TableCell align="center" sx={{
                backgroundColor: colors[parseInt(risk.D)===1 ? Math.ceil(risk.risks.availability) :  '-'],
                color: (theme) => {
                  const idx = parseInt(risk.D)===1 ? Math.ceil(risk.risks.availability) : '-';
                  const bg = colors[idx];
                  return bg ? theme.palette.getContrastText(bg) : theme.palette.text.primary;
                },
              }}>{(context.context?.length===0 && impact.length===0) ? '-' : parseInt(risk.D)===1 ? risk.risks.availability : ''}</TableCell>
              <TableCell align="center" sx={{
                borderRight:'1px solid rgba(0, 0, 0, 0.12)',
                backgroundColor: colors[Math.ceil(risk.maxRisk)],
                color: (theme) => {
                  const bg = colors[Math.ceil(risk.maxRisk)];
                  return bg ? theme.palette.getContrastText(bg) : theme.palette.text.primary;
                },
              }}>{(context.context?.length===0 && impact.length===0) ? '-' : risk.maxRisk}</TableCell>

              <TableCell align="center" sx={{
                backgroundColor: colors[parseInt(risk.R)===1 ? Math.ceil(risk.effective_risks.confidentiality) :  '-'],
                color: (theme) => {
                  const idx = parseInt(risk.R)===1 ? Math.ceil(risk.effective_risks.confidentiality) : '-';
                  const bg = colors[idx];
                  return bg ? theme.palette.getContrastText(bg) : theme.palette.text.primary;
                },
              }}>{(context.context?.length===0 && impact.length===0) ? '-' : parseInt(risk.R)===1 ? risk.effective_risks_detail.confidentiality : ''}</TableCell>
              <TableCell align="center" sx={{
                backgroundColor: colors[parseInt(risk.I)===1 ? Math.ceil(risk.effective_risks.integrity) :  '-'],
                color: (theme) => {
                  const idx = parseInt(risk.I)===1 ? Math.ceil(risk.effective_risks.integrity) : '-';
                  const bg = colors[idx];
                  return bg ? theme.palette.getContrastText(bg) : theme.palette.text.primary;
                },
              }}>{(context.context?.length===0 && impact.length===0) ? '-' : parseInt(risk.I)===1 ? risk.effective_risks_detail.integrity : ''}</TableCell>
              <TableCell align="center" sx={{
                backgroundColor: colors[parseInt(risk.D)===1 ? Math.ceil(risk.effective_risks.availability) :  '-'],
                color: (theme) => {
                  const idx = parseInt(risk.D)===1 ? Math.ceil(risk.effective_risks.availability) : '-';
                  const bg = colors[idx];
                  return bg ? theme.palette.getContrastText(bg) : theme.palette.text.primary;
                },
              }}>{(context.context?.length===0 && impact.length===0) ? '-' : parseInt(risk.D)===1 ? risk.effective_risks_detail.availability : ''}</TableCell>  
              <TableCell align="center" sx={{
                backgroundColor: colors[Math.ceil(risk.max_effective_risks)],
                color: (theme) => {
                  const bg = colors[Math.ceil(risk.max_effective_risks)];
                  return bg ? theme.palette.getContrastText(bg) : theme.palette.text.primary;
                },
              }}>{context.context?.length===0 && impact.length===0 ? '-' : risk.max_effective_risks_details}</TableCell>
            </TableRow>
            })}
        </TableBody>
      </Table>
    </TableContainer>
      )}
    </AppLayout>
  );
}

export default Risks;
